// @flow

import { findIndex, split } from 'ramda'

// eslint-disable-next-line complexity
export const extractInfo = (currentPath: string, referencePath: string) => {
  const currentParts = split('/', currentPath)
  const referenceParts = split('/', referencePath)

  const isTvRoot = currentParts.length === 3 && ['tv', 'radio'].includes(currentParts[1])

  const isListPage = ['categories', 'genres'].some((item) => currentParts.includes(item))

  if (isTvRoot) {
    const channelsIndex = findIndex(
      (p) => ['channels', 'radio-channels'].includes(p),
      referenceParts,
    )

    if (channelsIndex !== -1 && referenceParts.length > channelsIndex + 1) {
      const type = referenceParts[channelsIndex + 1]

      if (type === 'category' || type === 'genre') {
        return { id: null, subtype: type === 'category' ? 'categories' : 'genres' }
      }

      return { id: null, subtype: type }
    }
  }

  if (isListPage) {
    const typeIndex = findIndex((p) => p === 'category' || p === 'genre', referenceParts)

    if (typeIndex !== -1 && referenceParts.length > typeIndex + 1) {
      return { id: referenceParts[typeIndex + 1], subtype: null }
    }
  }

  return { id: null, subtype: null }
}
